import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AprComponent = {
  __typename?: 'APRComponent';
  annualRewardUSD?: Maybe<Scalars['String']>;
  rewardDescription?: Maybe<Scalars['String']>;
  rewardLogoUrl?: Maybe<Scalars['String']>;
  rewardName?: Maybe<Scalars['String']>;
  rewardVaultAddress?: Maybe<Scalars['String']>;
  token?: Maybe<TokenData>;
  type: Scalars['String'];
  value: Scalars['String'];
};

export type AprData = {
  __typename?: 'APRData';
  components: Array<AprComponent>;
  max: Scalars['String'];
  min: Scalars['String'];
};

export type CuratedPool = {
  __typename?: 'CuratedPool';
  address: Scalars['String'];
  label: Scalars['String'];
};

export type Lp = {
  __typename?: 'LP';
  accRewardTokenPerShare: Scalars['String'];
  allocPoint: Scalars['String'];
  apr?: Maybe<AprData>;
  lastRewardTime: Scalars['Int'];
  poolId: Scalars['Int'];
  rewardPoints?: Maybe<Array<Maybe<RewardPoint>>>;
  token: TokenData;
  totalStaked?: Maybe<Scalars['String']>;
  totalStakedUSD?: Maybe<Scalars['String']>;
};

export type PendingPoint = {
  __typename?: 'PendingPoint';
  amount?: Maybe<Scalars['String']>;
  pointToken?: Maybe<Scalars['String']>;
};

export type PoolData = {
  __typename?: 'PoolData';
  poolId: Scalars['String'];
  totalSwapVolumeUSD7Days?: Maybe<Scalars['String']>;
  totalSwapVolumeUSD24h?: Maybe<Scalars['String']>;
  totalSwapVolumeUSD30Days?: Maybe<Scalars['String']>;
  totalSwapVolumeUSD90Days?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  curatedPools: Array<CuratedPool>;
  poolData?: Maybe<PoolData>;
  poolsData: Array<PoolData>;
  reward?: Maybe<RewardData>;
  rewardContracts: Array<RewardContract>;
  rewards: Array<RewardData>;
  tokenPrice?: Maybe<TokenPriceData>;
  tokenPrices: Array<TokenPriceData>;
  user?: Maybe<UserReward>;
  users: Array<UserReward>;
};

export type QueryPoolDataArgs = {
  poolId: Scalars['String'];
};

export type QueryPoolsDataArgs = {
  poolIds: Array<Scalars['String']>;
};

export type QueryRewardArgs = {
  contractAddress: Scalars['String'];
};

export type QueryRewardContractsArgs = {
  lpAddresses?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryTokenPriceArgs = {
  address: Scalars['String'];
};

export type QueryTokenPricesArgs = {
  addresses: Array<Scalars['String']>;
};

export type QueryUserArgs = {
  address: Scalars['String'];
};

export type QueryUsersArgs = {
  userAddresses: Array<Scalars['String']>;
};

export type RewardContract = {
  __typename?: 'RewardContract';
  appUrl: Scalars['String'];
  lps: Array<RewardContractLp>;
  protocol: Scalars['String'];
  rewardsContract: Scalars['String'];
};

export type RewardContractLp = {
  __typename?: 'RewardContractLP';
  bundled: Scalars['Boolean'];
  lpToken: Scalars['String'];
  lpTokenAddress: Scalars['String'];
};

export type RewardData = {
  __typename?: 'RewardData';
  lps: Array<Lp>;
  rewardToken: TokenData;
  rewardTokenPerSecond: Scalars['String'];
  rewardTokens: Array<TokenData>;
  rewardsContract: Scalars['String'];
  totalAllocPoint: Scalars['String'];
};

export type RewardPoint = {
  __typename?: 'RewardPoint';
  rewardDescription?: Maybe<Scalars['String']>;
  rewardLogoUrl?: Maybe<Scalars['String']>;
  rewardName?: Maybe<Scalars['String']>;
  rewardPerYear?: Maybe<Scalars['String']>;
  rewardToken?: Maybe<TokenData>;
};

export type TokenData = {
  __typename?: 'TokenData';
  address: Scalars['String'];
  decimals: Scalars['Int'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  tokenPriceUSD?: Maybe<Scalars['String']>;
};

export type TokenPriceData = {
  __typename?: 'TokenPriceData';
  address: Scalars['String'];
  decimals?: Maybe<Scalars['Int']>;
  latestUSDPrice?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};

export type UserReward = {
  __typename?: 'UserReward';
  rewardContracts: Array<UserRewardContract>;
  totalClaimedPointsUSD?: Maybe<Scalars['String']>;
  totalClaimedRewardsUSD?: Maybe<Scalars['String']>;
  totalPendingPointsUSD?: Maybe<Scalars['String']>;
  totalPendingRewardsUSD?: Maybe<Scalars['String']>;
  totalStakedUSD?: Maybe<Scalars['String']>;
  userAddress: Scalars['String'];
};

export type UserRewardContract = {
  __typename?: 'UserRewardContract';
  rewardContract: Scalars['String'];
  userInfo: Array<UserRewardInfo>;
};

export type UserRewardInfo = {
  __typename?: 'UserRewardInfo';
  claimedRewards: Scalars['String'];
  pendingPoints?: Maybe<Array<Maybe<PendingPoint>>>;
  pendingRewards?: Maybe<Scalars['String']>;
  poolId: Scalars['Int'];
  rewardDebt?: Maybe<Scalars['String']>;
  stakedAmount: Scalars['String'];
};

export type GetCuratedPoolsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCuratedPoolsQuery = {
  __typename?: 'Query';
  curatedPools: Array<{ __typename?: 'CuratedPool'; address: string }>;
};

export type GetPoolDataQueryVariables = Exact<{
  poolId: Scalars['String'];
}>;

export type GetPoolDataQuery = {
  __typename?: 'Query';
  poolData?: {
    __typename?: 'PoolData';
    poolId: string;
    totalSwapVolumeUSD24h?: string | null;
    totalSwapVolumeUSD7Days?: string | null;
    totalSwapVolumeUSD30Days?: string | null;
    totalSwapVolumeUSD90Days?: string | null;
  } | null;
};

export type GetRewardsQueryVariables = Exact<{
  address: Scalars['String'];
}>;

export type GetRewardsQuery = {
  __typename?: 'Query';
  rewards: Array<{
    __typename?: 'RewardData';
    rewardsContract: string;
    rewardToken: {
      __typename?: 'TokenData';
      address: string;
      name: string;
      symbol: string;
      decimals: number;
    };
    lps: Array<{
      __typename?: 'LP';
      poolId: number;
      allocPoint: string;
      apr?: {
        __typename?: 'APRData';
        min: string;
        max: string;
        components: Array<{
          __typename?: 'APRComponent';
          type: string;
          value: string;
          rewardName?: string | null;
          rewardLogoUrl?: string | null;
          rewardDescription?: string | null;
          rewardVaultAddress?: string | null;
        }>;
      } | null;
      token: { __typename?: 'TokenData'; address: string };
    }>;
  }>;
  user?: {
    __typename?: 'UserReward';
    rewardContracts: Array<{
      __typename?: 'UserRewardContract';
      rewardContract: string;
      userInfo: Array<{
        __typename?: 'UserRewardInfo';
        poolId: number;
        stakedAmount: string;
        pendingRewards?: string | null;
        pendingPoints?: Array<{
          __typename?: 'PendingPoint';
          pointToken?: string | null;
          amount?: string | null;
        } | null> | null;
      }>;
    }>;
  } | null;
};

export type GetCurrentTokenPricesQueryVariables = Exact<{
  addresses: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetCurrentTokenPricesQuery = {
  __typename?: 'Query';
  prices: Array<{
    __typename?: 'TokenPriceData';
    address: string;
    latestUSDPrice?: string | null;
  }>;
};

export const GetCuratedPoolsDocument = gql`
  query GetCuratedPools {
    curatedPools {
      address
    }
  }
`;
export const GetPoolDataDocument = gql`
  query GetPoolData($poolId: String!) {
    poolData(poolId: $poolId) {
      poolId
      totalSwapVolumeUSD24h
      totalSwapVolumeUSD7Days
      totalSwapVolumeUSD30Days
      totalSwapVolumeUSD90Days
    }
  }
`;
export const GetRewardsDocument = gql`
  query GetRewards($address: String!) {
    rewards {
      rewardsContract
      rewardToken {
        address
        name
        symbol
        decimals
      }
      lps {
        poolId
        allocPoint
        apr {
          min
          max
          components {
            type
            value
            rewardName
            rewardLogoUrl
            rewardDescription
            rewardVaultAddress
          }
        }
        token {
          address
        }
      }
    }
    user(address: $address) {
      rewardContracts {
        rewardContract
        userInfo {
          poolId
          stakedAmount
          pendingRewards
          pendingPoints {
            pointToken
            amount
          }
        }
      }
    }
  }
`;
export const GetCurrentTokenPricesDocument = gql`
  query GetCurrentTokenPrices($addresses: [String!]!) {
    prices: tokenPrices(addresses: $addresses) {
      address
      latestUSDPrice
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper
) {
  return {
    GetCuratedPools(
      variables?: GetCuratedPoolsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GetCuratedPoolsQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<GetCuratedPoolsQuery>(
            GetCuratedPoolsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetCuratedPools',
        'query'
      );
    },
    GetPoolData(
      variables: GetPoolDataQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GetPoolDataQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<GetPoolDataQuery>(GetPoolDataDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetPoolData',
        'query'
      );
    },
    GetRewards(
      variables: GetRewardsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GetRewardsQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<GetRewardsQuery>(GetRewardsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetRewards',
        'query'
      );
    },
    GetCurrentTokenPrices(
      variables: GetCurrentTokenPricesQueryVariables,
      requestHeaders?: Dom.RequestInit['headers']
    ): Promise<GetCurrentTokenPricesQuery> {
      return withWrapper(
        wrappedRequestHeaders =>
          client.request<GetCurrentTokenPricesQuery>(
            GetCurrentTokenPricesDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders }
          ),
        'GetCurrentTokenPrices',
        'query'
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
